import React, { useState, useEffect, useRef } from "react";
import "./AppSpinner.css";

const AppSpinner = ({
  show = true,
  fullscreen = false,
  text = "Yüklənir...",
  inline = false,
  minMs = 500,
}) => {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);
  const startRef = useRef(null);

  useEffect(() => {
    if (inline) return;
    if (show) {
      startRef.current = Date.now();
      setVisible(true);
      clearTimeout(timerRef.current);
    } else {
      const elapsed = Date.now() - (startRef.current || 0);
      const remaining = minMs - elapsed;
      if (remaining > 0) {
        timerRef.current = setTimeout(() => setVisible(false), remaining);
      } else {
        setVisible(false);
      }
    }
    return () => clearTimeout(timerRef.current);
  }, [show, minMs, inline]);

  if (inline) {
    return show ? (
      <span className="app-spinner-inline" aria-label="yüklənir">
        <span className="app-spinner-ring-sm" />
      </span>
    ) : null;
  }

  if (!visible) return null;

  const inner = (
    <>
      <div className="app-spinner-ring" />
      {text && <p className="app-spinner-text">{text}</p>}
    </>
  );

  if (fullscreen) {
    return <div className="app-spinner-overlay" role="status">{inner}</div>;
  }

  return <div className="app-spinner-centered" role="status">{inner}</div>;
};

export default AppSpinner;
